import React from 'react';
import { Card } from 'react-bootstrap';

const body  = (props) => {        
    return (        
        <Card style={{ marginLeft: '68px', maxWidth: "100%", marginRight: "5px", display: "block" }}>
            <Card.Body>
                {props.children}
            </Card.Body>
        </Card>        
    )   
}

export default body;